import React from 'react'
import Editor from 'components/Editor'
import styled from 'react-emotion'
import { LayoutWithStandardHeader, color } from 'stylist'
import EnsureSession from '../components/EnsureSession'

const Main = styled(LayoutWithStandardHeader.Main)`
  width: 100%;
  padding: 0;
  color: ${color('pewter')};
`

const RouteEditor = props => {
  return (
    <EnsureSession errorMessage={'This page is only accessible via Decipher.'}>
      <LayoutWithStandardHeader>
        <Main>
          <Editor ref={editor => (this.editor = editor)} />
        </Main>
      </LayoutWithStandardHeader>
    </EnsureSession>
  )
}

export default RouteEditor



// WEBPACK FOOTER //
// ./src/routes/editor.js